import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

import { ref } from 'vue';
const _withScopeId = n => (_pushScopeId("data-v-2fc6edce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search"
};
const _hoisted_2 = {
  class: "lable"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "submit"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "submit",
  type: "submit"
}, "搜索")], -1));
export default {
  __name: 'search',
  emits: ['submit', 'onleBlur'],
  setup(__props, {
    emit: emits
  }) {
    let content = ref('');
    let onSubmit = e => {
      e.preventDefault();
      emits('submit', content.value);
    };
    let handleInputChange = e => {
      console.log(e);
      emits('onleBlur', content.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = (...args) => _unref(onSubmit) && _unref(onSubmit)(...args)),
        class: "form"
      }, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(content) ? content.value = $event : content = $event),
        placeholder: "搜索文章相关标题",
        onChange: _cache[1] || (_cache[1] = (...args) => _unref(handleInputChange) && _unref(handleInputChange)(...args))
      }, null, 544), [[_vModelText, _unref(content)]])]), _hoisted_3], 32)]);
    };
  }
};